import React from 'react';
import { ImageOptimizer } from '@/components/seo/ImageOptimizer';
const HeroImage = () => {
  return (
    <ImageOptimizer 
      src="/lovable-uploads/c4b7fb46-8ea2-4549-bc48-e08aac3d44e6.png" 
      alt="Professional consultation meeting between advisor and senior client" 
      className=""
      imgClassName="w-full h-64 md:h-80 lg:h-96 object-cover"
      sizes="100vw"
      width={800}
      height={384}
      quality={85}
      priority={true}
    />
  );
};

export default HeroImage;
